module.exports = __webpack_public_path__ + "img/horn_1.0b6dd8b3.png";